export default "__VITE_ASSET__CAO347Gs__"